module.exports = __webpack_public_path__ + "img/37.e1793421.jpg";